import { gql } from '@apollo/client';

export const EXPORT_FUNDER_TREATMENT_GROUPS = gql`
  query ExportFunderTreatmentGroups($input: ExportArgs) {
    stakeholders: funderStakeholders(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          branch
          careGiverContactNumber
          careGiverEmailAddress
          careGiverEmployer
          careGiverGender {
            name
          }
          careGiverMaritalStatus
          careGiverName
          careGiverNationalId
          careGiverOccupation
          careGiverPhysicalAddress
          careGiverRelationship
          careGiverSurname
          careGiverType
          communityType {
            name
          }
          contactNumber
          country {
            name
          }
          dateExited
          dateOfBirth
          designation
          disability
          disabilityTypes {
            name
          }
          district {
            name
          }
          educatorLevel {
            name
          }
          emailAddress
          firstName
          gender {
            name
          }
          grades {
            value
          }
          highestQualification {
            name
          }
          homeLanguage {
            name
          }
          ictSkill {
            name
          }
          id
          institutions {
            emisNumber
            name
          }
          lastName
          leadEducator
          localMunicipality {
            id
            localMunicipality
          }
          multiGrade
          nationalID
          natureOfEmployment {
            name
          }
          ovc
          persalNumber
          personnelPosition {
            name
          }
          personnelPositionOther
          phase {
            name
          }
          populationGroup {
            name
          }
          postLevel
          prePrimaryExperience
          primaryInstitution {
            emisNumber
            name
          }
          province {
            name
          }
          reasonForTermination {
            name
          }
          region {
            name
          }
          renumerationSource {
            name
          }
          role {
            name
          }
          subjects {
            subjectGradeReference
          }
          trackingId
          type {
            name
          }
          yearsOfExperience
          yearsInGrade
          yearsInPhase
          # intervention fields
          interventions {
            id
            name
            fromDate
            toDate
            class {
              id
              name
            }
            grades {
              id
              name
              value
            }
            programme {
              id
              name
            }
            serviceProviders {
              id
              name
            }
            subjects {
              id
              name
              subjectGradeReference
            }
          }
        }
      }
    }
  }
`;
